export const fetchSitemapData = async () => {
    try {
        const response = await fetch('./content/sitemap/sitemap.json', {
            cache: "no-cache"
        });
        return await response.json();
    } catch (e) {
        console.log(e);
    }
};



// WEBPACK FOOTER //
// ./src/api/fetchSitemapData.js